import React, { Component } from "react";


const PostContent = (props) => {
    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    )
}

export default PostContent;
